import { render } from "./PrivacyPolicy.vue?vue&type=template&id=3392d0fc&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=ts"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=3392d0fc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3392d0fc"

export default script